import { Component, OnInit } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { Router, ActivatedRoute } from '@angular/router';

import { greviencemodel } from '../../models/grevience/grevience.model';
import {IMyDpOptions} from 'mydatepicker';


@Component({
  selector: 'app-request-manage',
  templateUrl: './paymentResponse.component.html'
})
export class newPaymentResponseComponent implements OnInit {

  //variable deceleration
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  public allRequestData : any = [];
  public allCategoryData : any = [];
  public allSubData : any = [];
  public greviencemodel: greviencemodel = new greviencemodel;
  public popupopen : boolean = false;
  public viewpopupopen : boolean = false;
  public viewStatus : string = "";
  public viewDate : any = "";
  public viewDocket : any = "";
  public viewCat : any = "";
  public viewSubCat : any = "";
  public viewDetails : string = "";
  public checkSumData : any = "";
  public paymentStat : any = "";
  public getTokkendata : any = "";
  public paymentStatus : number;
  public isHidePaymentStatus : boolean = false;
  public paymentResponseDet :any = {}
   
   public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
		disableUntil : { year: new Date().getFullYear(), month: new Date().getMonth()+1, day: new Date().getDate()-1 }
    };

  constructor(public http: HttpTestService, public session: sessionServices, public router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
	  this.getSession();
	  var URL:any = window.location.href;
	  //this.fetchauthKeyFromUrl();
	  this.fetchauthKeyFromParameter();
  }
  
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
	}

	fetchauthKeyFromParameter = function(){
		
		this.getTokkendata = this.route.snapshot.paramMap.get('msg');
		var paramSeperatorIndex = this.getTokkendata.indexOf("&");
		var paymentprocessingstatus = this.getTokkendata.substring(0, paramSeperatorIndex);
		var paymentprocessingmessage = this.getTokkendata.substring(paramSeperatorIndex + 1);
		var paramSeperatorIndex1 = paymentprocessingstatus.indexOf("=");
		var paymentprocessingstatusvalue = paymentprocessingstatus.substring(paramSeperatorIndex1);
		var paramSeperatorIndex2 = paymentprocessingmessage.indexOf("=");
		var paymentprocessingmessagevalue = paymentprocessingmessage.substring(paramSeperatorIndex2);

	   var paymentArr = this.getTokkendata.split("&");
	   var statusEl = paymentArr[paymentArr.length-2];
	   var statusArr = statusEl.split("=");
	   var paymentReferenceEl = paymentArr[paymentArr.length-3];
	   var paymentReferenceArr = paymentReferenceEl.split("=");
	   this.paymentResponseDet.paymentReference = paymentReferenceArr[1];
	   this.paymentResponseDet.status = statusArr[1].toUpperCase();
	   this.paymentResponseDet.heading = this.paymentResponseDet.status === 'SUCCESS' ? "Successful Acknowledgement" : "Failure Information";
	   if(this.paymentResponseDet.status != "SUCCESS"){
		var reasonEl = paymentArr[paymentArr.length-1];
		var reasonArr = reasonEl.split("=");
		var reason = reasonArr[1].split("_");
		var reasonStr = "";
		reason.forEach(element => {
			reasonStr = reasonStr +" "+ element;
		});
		this.paymentResponseDet.status = "UNSUCCESSFUL & "+ reasonStr; 
	   }
	   this.paymentStatus = paymentprocessingstatusvalue;
	   var billPeriodEl = paymentArr[paymentArr.length-8];
	   var billPeriodArr = billPeriodEl.split("=");
	   this.paymentResponseDet.billPeriod = billPeriodArr[1];
	   var consumerIdEl = paymentArr[paymentArr.length-7];
	   var consumerIdArr = consumerIdEl.split("=");
	   this.paymentResponseDet.consumerId = consumerIdArr[1];
	   var amountEl = paymentArr[paymentArr.length-6];
	   var amountArr = amountEl.split("=");
	   this.paymentResponseDet.paymentAmount = amountArr[1];
	   var dateOfTransactionEl = paymentArr[paymentArr.length-5];
	   var dateOfTransactionArr = dateOfTransactionEl.split("=");
	   this.paymentResponseDet.dateOfTransaction = dateOfTransactionArr[1];
	   var paymentStatusValue = this.paymentStatus.replace("=","");
	  //alert(paymentStatusValue);
	   if(paymentStatusValue == 1){
		for (let index = 0; index < paymentprocessingmessagevalue.length; index++) {
			paymentprocessingmessagevalue = paymentprocessingmessagevalue.replace("%20", " ");
			paymentprocessingmessagevalue = paymentprocessingmessagevalue.replace("="," ");
			paymentprocessingmessagevalue = paymentprocessingmessagevalue.replace("%27"," ");
		}
  		   this.successMsg = paymentprocessingmessagevalue;
	   }else if(paymentStatusValue == -1){
        for (let index = 0; index < paymentprocessingmessagevalue.length; index++) {
			paymentprocessingmessagevalue = paymentprocessingmessagevalue.replace("%20", " ");
			paymentprocessingmessagevalue = paymentprocessingmessagevalue.replace("="," ");
			
		}
		
		this.errorMsg = paymentprocessingmessagevalue;
		
		}else if(paymentStatusValue == 2){
           this.isHidePaymentStatus = true;
		}
	}
	
	fetchauthKeyFromUrl = function(){
		//alert("Fetch Auth");
		var tokken:any = window.location.href;
		tokken = tokken.split("?");
		//alert("Tkn: "+tokken);
		var requestedUrl = window.location.pathname;
		this.getRequestedUrl = requestedUrl;
		if(tokken.length>1){
		tokken = tokken[1].split("="); 
		}
		if(tokken.length>1){
		this.getTokkendata = tokken[1];
		//alert("Tkn data Previous: "+this.getTokkendata);
	   }
		if(this.getTokkendata != ""){
			this.checkChecksum()
		}
		
	}

	checkChecksumAndPostPayment = function(msgWithoutChksum,billdeskCheckSum){
		var self = this;
		
		  self.http.getChecksum(msgWithoutChksum)
		  .subscribe(
			(data) => {
			  self.checkSumData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.checkSumData = "";
			},
			() => {
				
					
					var getPaymentData = self.getTokkendata.split("%7C");
					var checkAuthCode =  getPaymentData[14];
					
					if(checkAuthCode == '0300'){
						self.processPayment();
						}else{
						}
					//self.processPayment();
				}
				
				
			
	);
		
	}
	
	
	checkChecksum = function(){
		var self = this;
		var requestedString = self.getTokkendata;
		requestedString = requestedString.split("%7C");
		var prevChcksum = requestedString[requestedString.length-1];
		requestedString.pop();
		requestedString = requestedString.join("%7C");
		requestedString = requestedString.split("%2F");
		requestedString = requestedString.join("fwdSlash");
		self.http.getChecksum(requestedString)
		  .subscribe(
			(data) => {
			  self.checkSumData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.checkSumData = "";
			},
			() => {
				if(prevChcksum == self.checkSumData.value){
				
				}else{
					self.getTokkendata = "";
				}
				
				
			}
	);
		
	}
	
processPayment = function(){
	var self = this;
	var getPaymentData = self.getTokkendata.split("%7C");

	if(getPaymentData[13].indexOf("%2B")> -1){
	var formattedDate = getPaymentData[13].split("%2B")[0].split("-")[2]+"-"+getPaymentData[13].split("%2B")[0].split("-")[1]+"-"+getPaymentData[13].split("%2B")[0].split("-")[0];
	var formatTime = getPaymentData[13].split("%2B")[1];
	}else{
	var formattedDate = getPaymentData[13].split("%20")[0].split("-")[2]+"-"+getPaymentData[13].split("%20")[0].split("-")[1]+"-"+getPaymentData[13].split("%20")[0].split("-")[0];
	var formatTime = getPaymentData[13].split("%20")[1];
	}
	var postParamGaya = {
    amount:getPaymentData[4],
	customerId:getPaymentData[1],
    consumerId:getPaymentData[20],
    date:formattedDate,
    lastupdatedDate:formattedDate,
    mobNo:getPaymentData[21],
    orderNo:getPaymentData[22],
    time:formatTime,
    transactionId:getPaymentData[2],
	lvDocType:getPaymentData[7],
	authCode:getPaymentData[14]

}
	self.http.postPaymentGaya(postParamGaya)
		  .subscribe(
			(data) => {
			  self.paymentStat = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.paymentStat = "";
			},
			() => {}
	);
	
}
print(divName){
		var printContents = document.getElementById(divName).innerHTML;
		var originalContents = document.body.innerHTML;
		document.body.innerHTML = printContents;
		window.print();
		document.body.innerHTML = originalContents;
 
}




}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/paymentResponse/paymentResponse.component.ts